export const langMap = {
  pt: {
    PayTip: 'Proteção de Pagamento do Kwai',
    Confirm: 'Confirmar',
    Amount: 'Valor'
  },
  zh: {
    PayTip: '快手支付保护',
    Confirm: '确认',
    Amount: '金额'
  },
  en: {
    PayTip: 'Kwai Payment Protection',
    Confirm: 'Confirm',
    Amount: 'Amount'
  },
  ar: {
    PayTip: 'حماية الدفع لـKwai',
    Confirm: 'تأكيد',
    Amount: 'مبلغ'
  },
  bn: {
    PayTip: 'Kwai পেমেন্ট নিরাপত্তা',
    Confirm: 'নিশ্চিত করুন',
    Amount: "রাশি"
  },
  es: {
    PayTip: 'Protección de Pago de Kwai',
    Confirm: 'Confirmar',
    Amount: 'Cantidad'
  },
  id: {
    PayTip: 'Perlindungan Pembayaran SnackVideo',
    Confirm: 'Konfirmasi',
    Amount: 'Jumlah'
  },
  th: {
    PayTip: 'การป้องกันการชําระเงินSnackVideo',
    Confirm: 'ยืนยัน',
    Amount: 'ผลรวมของเงิน'
  },
  tr: {
    PayTip: 'Kwai Ödeme Koruması',
    Confirm: 'Onayla',
    Amount: 'Tutar'
  },
  ur: {
    PayTip: 'SnackVideo ادائیگی تحفظ',
    Confirm: 'تصدیق کریں',
    Amount: 'رقم'
  },
  in: {
    PayTip: 'Perlindungan Pembayaran SnackVideo',
    Confirm: 'Konfirmasi',
    Amount: 'Jumlah'
  }
};